import { SurveyDocumentGroupsService } from '@api/domains/survey-document-groups/services';
import { useAxios } from '@api/hooks';
import { useMemo } from 'react';

export const useSurveyDocumentGroupsApi = () => {
  const axios = useAxios();
  return useMemo(() => new SurveyDocumentGroupsService(axios), [axios]);
};
